'use client';

import React from 'react';
import styled from 'styled-components';
import { Skeleton } from '@/components/skeletons/Skeleton';

// ============================================================================
// Styled Components
// ============================================================================

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px 0;
`;

const SkeletonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SkeletonActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// ============================================================================
// Component
// ============================================================================

export interface FilterModalSkeletonProps {
  /** Number of filter sections */
  sections?: number;
  /** Show action buttons */
  showActions?: boolean;
}

/**
 * FilterModalSkeleton Component
 * 
 * Loading skeleton for filter modal
 * 
 * @component
 * @example
 * ```tsx
 * <FilterModalSkeleton sections={3} />
 * ```
 */
export const FilterModalSkeleton: React.FC<FilterModalSkeletonProps> = ({
  sections = 3,
  showActions = true,
}) => {
  return (
    <SkeletonContainer>
      {Array.from({ length: sections }).map((_, index) => (
        <SkeletonSection key={index}>
          <Skeleton width="120px" height="14px" />
          <Skeleton width="100%" height="40px" borderRadius="8px" animation="wave" />
        </SkeletonSection>
      ))}

      {showActions && (
        <SkeletonActions>
          <Skeleton width="100px" height="40px" borderRadius="8px" />
          <Skeleton width="120px" height="40px" borderRadius="8px" />
        </SkeletonActions>
      )}
    </SkeletonContainer>
  );
};

export default FilterModalSkeleton;

